import { Directive, Output, EventEmitter, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OutsideEventDirective } from './outside-event.directive';

@Directive({
  selector: '[wfmOutsideClick]'
})
export class OutsideClickDirective extends OutsideEventDirective {
  @Output() wfmOutsideClick: EventEmitter<any>;

  constructor(@Inject(DOCUMENT) document, element: ElementRef) {
    super(document, element, 'click');
    this.wfmOutsideClick = this.wfmOutsideEvent;
  }
}
